export default __webpack_public_path__ + "static/char-s-04-en-08936dd9726bd3a0468de6c656397a85.webp";